import { Options, TooltipFormatterContextObject } from 'highcharts';
import { map } from 'lodash';
import { Translate } from 'hooks/use-translation';
import { ChartZoomLevel } from '../chart-with-zoom';
import { ChartTextStyle } from '../components';
import { TooltipStyle } from '../template-insight-tooltip';

export type Epoch = number;
export type DeviationMeta = {
  deviation: Array<number>;
  average: number;
};

const getDeviations = (meta: Record<Epoch, DeviationMeta>) =>
  map(meta, (val, key) => [Number(key), val.average]).sort(
    ([a], [b]) => Number(a) - Number(b),
  );

type LineChartConfig = {
  xAxisTitle: string;
  showLegend: boolean;
  tooltipFormatter: (
    tooltip: TooltipFormatterContextObject,
    zoomLevel: ChartZoomLevel,
    deviationMetaByZoomLevel: Record<
      string,
      Record<ChartZoomLevel, Record<Epoch, DeviationMeta>>
    >,
  ) => string;
};
export const getLineChartOption = (
  zoomLevel: ChartZoomLevel,
  deviationMetaByZoomLevel: Record<
    string,
    Record<ChartZoomLevel, Record<Epoch, DeviationMeta>>
  >,
  translate: Translate,
  config: LineChartConfig,
): Options => {
  return {
    colors: ['#0f62fe', '#161616'],
    xAxis: {
      type: 'datetime',
      title: {
        text: config.xAxisTitle,
      },
      ...ChartTextStyle,
    },
    yAxis: {
      title: {
        text: translate(
          'reports.template_insight.by-template.by-project.chart.yAxis',
        ),
      },
      ...ChartTextStyle,
    },
    tooltip: {
      formatter() {
        return config.tooltipFormatter(
          this,
          zoomLevel,
          deviationMetaByZoomLevel,
        );
      },
      ...TooltipStyle,
    },
    plotOptions: {
      series: {
        marker: {
          enabled: true,
        },
      },
    },
    legend: {
      enabled: config.showLegend,
      itemStyle: ChartTextStyle.style,
    },
    series: Object.entries(deviationMetaByZoomLevel).map(([title, meta]) => ({
      data: getDeviations(meta[zoomLevel]),
      type: 'line',
      showInLegend: config.showLegend,
      name: title,
    })),
  };
};
